import type { FC } from "react";

import { isOneOf } from "@arti/utilities";

import { useTabParam } from "../../hooks/useTabParam";
import { type Tab, Tabs } from "../common/Tabs";
import UsageView from "../usage/UsageView";
import { QuotaForecastingView } from "./QuotaForecastingView";
import { TimingsView } from "./TimingsView";

const STATISTICS_TABS: Tab[] = [
  { id: "usage", label: "Usage & Cost" },
  { id: "quota", label: "Quota Forecasting" },
  { id: "timings", label: "Timings" },
];

type StatisticsTab = "usage" | "quota" | "timings";

const DEFAULT_TAB: StatisticsTab = "usage";

export const StatisticsView: FC = () => {
  const [rawTab, setActiveTab] = useTabParam<StatisticsTab>(DEFAULT_TAB);
  const resolvedTab = STATISTICS_TABS.some((tab) => tab.id === rawTab)
    ? rawTab
    : DEFAULT_TAB;
  const activeView = (() => {
    if (resolvedTab === "timings") {
      return <TimingsView />;
    }
    if (resolvedTab === "quota") {
      return <QuotaForecastingView />;
    }
    return <UsageView />;
  })();

  return (
    <div className="space-y-4">
      <Tabs
        tabs={STATISTICS_TABS}
        activeTab={resolvedTab}
        onChange={(tabId) => {
          if (isOneOf<StatisticsTab>(tabId, ["usage", "quota", "timings"])) {
            setActiveTab(tabId);
          }
        }}
        ariaLabel="Statistics tabs"
      />
      {activeView}
    </div>
  );
};

export default StatisticsView;
